import { Button } from "../ui/button";
import { useNavigate } from "react-router-dom";

function CartModal({
  open,
  onClose,
  products,
  onIncrement,
  onDecrement,
  total,
}) {
  const navigate = useNavigate();

  if (!open) return null;

  const handleCheckout = () => {
    onClose(); // close the modal first
    navigate("/checkout");
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-end">
      <div className="w-full max-w-md bg-white shadow-2xl p-6 h-full overflow-y-auto relative">
        <button
          className="absolute top-3 right-3 text-gray-500 hover:text-black text-2xl"
          onClick={onClose}
          aria-label="Close"
        >
          &times;
        </button>

        <h2 className="text-2xl font-bold mb-2 secdory-font">Shopping Bag</h2>
        <p className="text-md text-slate-600">
          Keep your essentials ready to go
        </p>

        <div className="mt-10">
          {products.length === 0 && (
            <p className="text-center text-gray-500 py-10">
              Your cart is empty.
            </p>
          )}

          {products.map((item, i) => (
            <div key={i} className="flex items-center mb-6 space-x-4">
              <div className="custom-bg px-2 py-2 rounded-lg border border-gray-200">
                <img
                  src={item.image}
                  alt={item.name}
                  className="h-16 object-cover rounded-md"
                />
              </div>

              <div className="flex-1 min-w-0">
                <div className="text-md font-semibold truncate">
                  {item.name}
                </div>
                <div className="text-sm text-gray-500 line-through mr-1 inline">
                  ${item.oldPrice}
                </div>
                <span className="font-semibold">${item.price}</span>
              </div>

              {/* Quantity control */}
              <div className="flex items-center border rounded-md px-2 py-1">
                <button
                  className="px-3 text-xl hover:text-red-500 transition"
                  onClick={() => onDecrement(i)}
                  aria-label={`Decrease quantity of ${item.name}`}
                >
                  -
                </button>
                <span className="mx-3 min-w-6 text-center">
                  {item.quantity}
                </span>
                <button
                  className="px-3 text-xl hover:text-green-500 transition"
                  onClick={() => onIncrement(i)}
                  aria-label={`Increase quantity of ${item.name}`}
                >
                  +
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="flex justify-between font-bold text-lg mt-4 mb-6">
          <span>Total price:</span>
          <span>${total.toFixed(2)}</span>
        </div>

        <Button
          onClick={handleCheckout}
          disabled={products.length === 0}
          className="w-full bg-primary text-white py-3 rounded-md font-semibold hover:bg-gray-800 transition disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Check Out
        </Button>
      </div>
    </div>
  );
}

export default CartModal;
